import { pdfjs } from "react-pdf";
import { YearSection } from "@/components/financial-statements/YearSection";
import { financialStatementsConfig } from "@/config/financialStatementsConfig";

// Set up the worker for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const FinancialStatements = () => {
  return (
    <>
      <style>{`
        @media print {
          .financial-statements-container {
            display: none !important;
          }
        }
      `}</style>
      <div className="financial-statements-container max-w-7xl mx-auto space-y-8 pb-12">
        <div>
          <h1 className="text-4xl font-bold text-foreground mb-2">
            Financial Statements
          </h1>
        </div>

        <div className="space-y-8">
          {financialStatementsConfig.map((yearData) => (
            <YearSection
              key={yearData.year}
              year={yearData.year}
              reports={yearData.reports}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default FinancialStatements;
